import type {ReduxState} from '@/redux'

export const proveAllCampaigns = (state: ReduxState) => state.proveCampaign.available;
export const proveSelectedCampaign = (state: ReduxState) => state.proveCampaign.selected;
export const proveCampaignIsPending = (state: ReduxState) => state.proveCampaign.isPending;
export const proveCampaignIsError = (state: ReduxState) => state.proveCampaign.isError;
